// src/common/query/StreetViewCanvas.jsx
import React, { useEffect, useRef, useState } from "react";
import { Loader } from "@googlemaps/js-api-loader";

export default function StreetView({ address, height = 460, radius = 60 }) {
  const divRef = useRef(null);
  const [err, setErr] = useState("");

  useEffect(() => {
    let canceled = false;
    let pano = null;

    (async () => {
      try {
        if (!address) return;
        setErr("");

        const loader = new Loader({
          apiKey: "AIzaSyDNZ5JW-VEniKiFdSoySNFQdyhuaOu9YIc",
          version: "weekly",
          language: "pt-BR",
          region: "BR",
        });
        await loader.load();
        if (canceled) return;

        const geocoder = new window.google.maps.Geocoder();
        geocoder.geocode({ address: address.trim() }, (results, status) => {
          if (canceled) return;
          if (status !== "OK" || !results?.length) {
            setErr("Endereço não encontrado.");
            return;
          }
          const loc = results[0].geometry?.location;
          if (!loc) {
            setErr("Sem coordenadas para o endereço.");
            return;
          }

          const svs = new window.google.maps.StreetViewService();
          svs.getPanorama({ location: loc, radius }, (data, svStatus) => {
            if (canceled) return;
            if (svStatus === "OK" && data?.location?.latLng) {
              pano = new window.google.maps.StreetViewPanorama(divRef.current, {
                position: data.location.latLng,
                pov: { heading: 0, pitch: 0 },
                zoom: 1,
                addressControl: false,
                fullscreenControl: false,
                linksControl: true,
                panControl: true,
                motionTracking: false,
              });
            } else {
              setErr("Não há cobertura de Street View neste endereço.");
            }
          });
        });
      } catch (e) {
        setErr("Falha ao carregar o Google Maps.");
      }
    })();

    return () => {
      canceled = true;
      if (divRef.current) divRef.current.innerHTML = "";
      pano = null;
    };
  }, [address, radius]);

  return (
    <div
      style={{ height }}
      className="w-full rounded-xl overflow-hidden border border-gray-200 bg-gray-50"
    >
      {err ? (
        <div className="p-3 text-sm text-gray-600">{err}</div>
      ) : (
        <div ref={divRef} style={{ width: "100%", height: "100%" }} />
      )}
    </div>
  );
}
